module.exports = __webpack_public_path__ + "img/switzerland-cervical-cancer-female.fdc8919e.png";